import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function LegalPage({ title, updatedAt, intro, sections }) {
  return (
    <>
      <Navbar />
      <main style={styles.page}>
        <div className="container" style={styles.container}>
          <div style={styles.hero}>
            <span style={styles.eyebrow}>GoalFit</span>
            <h1 style={styles.title}>{title}</h1>
            <p style={styles.meta}>Dernière mise à jour : {updatedAt}</p>
            <p style={styles.intro}>{intro}</p>
          </div>

          <div style={styles.card}>
            {sections.map((section) => (
              <section key={section.heading} style={styles.section}>
                <h2 style={styles.sectionTitle}>{section.heading}</h2>
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} style={styles.paragraph}>
                    {paragraph}
                  </p>
                ))}
                {section.bullets ? (
                  <ul style={styles.list}>
                    {section.bullets.map((bullet) => (
                      <li key={bullet} style={styles.listItem}>
                        {bullet}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top, rgba(26,90,255,0.22), transparent 32%), linear-gradient(180deg, #07111f 0%, #0b1222 100%)",
    paddingBottom: 80,
  },
  container: {
    paddingTop: 40,
  },
  hero: {
    maxWidth: 760,
    margin: "0 auto 28px",
  },
  eyebrow: {
    display: "inline-block",
    fontSize: 12,
    letterSpacing: "0.18em",
    textTransform: "uppercase",
    color: "#78a6ff",
    marginBottom: 12,
  },
  title: {
    fontSize: "clamp(2.2rem, 5vw, 3.5rem)",
    lineHeight: 1.05,
    margin: 0,
  },
  meta: {
    color: "#a8b6d8",
    marginTop: 12,
    marginBottom: 10,
  },
  intro: {
    color: "#d7e2ff",
    lineHeight: 1.7,
    fontSize: 17,
    maxWidth: 720,
  },
  card: {
    maxWidth: 820,
    margin: "0 auto",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(145, 177, 255, 0.16)",
    borderRadius: 28,
    padding: "30px 24px",
    backdropFilter: "blur(16px)",
    boxShadow: "0 24px 70px rgba(0,0,0,0.28)",
  },
  section: {
    padding: "10px 0 8px",
  },
  sectionTitle: {
    marginBottom: 12,
    fontSize: 24,
  },
  paragraph: {
    color: "#d4def8",
    lineHeight: 1.8,
    margin: "0 0 14px",
  },
  list: {
    margin: "0 0 16px 18px",
    padding: 0,
    color: "#d4def8",
  },
  listItem: {
    marginBottom: 10,
    lineHeight: 1.7,
  },
};
